package ru.villawonka.app.presentation.screens.searchFilter.compose

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.koinScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.Navigator
import cafe.adriel.voyager.navigator.currentOrThrow
import org.koin.compose.koinInject
import org.koin.core.parameter.parametersOf
import ru.villawonka.app.domain.model.AccommodationAdditionDomain
import ru.villawonka.app.domain.model.AccommodationTypeDomain
import ru.villawonka.app.domain.model.SearchParamsDomain
import ru.villawonka.app.getTelegram
import ru.villawonka.app.platform.platform.Platform
import ru.villawonka.app.presentation.screens.searchFilter.compose.layout.SearchFilterRootLayout
import ru.villawonka.app.presentation.screens.searchFilter.model.ChipUIModel
import ru.villawonka.app.presentation.screens.searchFilter.viewmodel.SearchFilterUIEvent
import ru.villawonka.app.presentation.screens.searchFilter.viewmodel.SearchFilterUIState
import ru.villawonka.app.presentation.screens.searchFilter.viewmodel.SearchFilterViewModel

class SearchFilterScreen(
    val inputParams: Params.Input,
    val onResult: (Params.Output) -> Unit,
) : Screen {

    sealed interface Params {

        /**
         * @property searchParamsDomain Последние сохраненные параметры поиска
         */
        data class Input(
            val searchParamsDomain: SearchParamsDomain,
        )

        /**
         * @property searchParamsDomain Новые параметры поиска
         */
        data class Output(
            val searchParamsDomain: SearchParamsDomain
        )
    }

    @Composable
    override fun Content() {
        getTelegram()?.setBackButtonVisible(true)

        val navigator = LocalNavigator.currentOrThrow
        val viewModel = koinScreenModel<SearchFilterViewModel> { parametersOf(inputParams) }
        val platform = koinInject<Platform>()
        val state by viewModel.uiState.collectAsStateWithLifecycle(SearchFilterUIState.Loading)

        SearchFilterRootLayout(
            state = state,
            platformType = platform.type,
            callbacks = remember {
                SearchFilterCallbacks(
                    onClearButtonClick = viewModel::onClearButtonClick,
                    onCloseButtonClick = viewModel::onCloseButtonClick,
                    onApplyButtonClick = viewModel::onApplyButtonClick,
                    onCityValueChanged = viewModel::onCityValueChanged,
                    onDistrictChipClick = viewModel::onDistrictChipClick,
                    onCostMinValueChanged = viewModel::onCostMinValueChanged,
                    onCostMaxValueChanged = viewModel::onCostMaxValueChanged,
                    onAccommodationTypeChipClick = viewModel::onAccommodationTypeChipClick,
                    onRoomsCountChipClick = viewModel::onBedroomsChipClick,
                    onAdditionsItemClick = viewModel::onAdditionsChipClick,
                    onRetryButtonClick = viewModel::onRetryButtonClick
                )
            }
        )

        registerUIEventListener(viewModel, navigator)
    }

    @Composable
    private fun registerUIEventListener(viewModel: SearchFilterViewModel, navigator: Navigator) {
        LaunchedEffect(Unit) {
            viewModel.events.collect { event ->
                when (event) {
                    is SearchFilterUIEvent.Close -> {
                        event.searchParamsDomain?.let {
                            onResult(Params.Output(it))
                        }
                        navigator.pop()
                    }
                }
            }
        }
    }
}

data class SearchFilterCallbacks(
    val onClearButtonClick: () -> Unit,
    val onCloseButtonClick: () -> Unit,
    val onApplyButtonClick: () -> Unit,

    val onCityValueChanged: (String) -> Unit,
    val onDistrictChipClick: (ChipUIModel<String>) -> Unit,

    val onCostMinValueChanged: (Int?) -> Unit,
    val onCostMaxValueChanged: (Int?) -> Unit,

    val onAccommodationTypeChipClick: (ChipUIModel<AccommodationTypeDomain>) -> Unit,
    val onRoomsCountChipClick: (ChipUIModel<String>) -> Unit,
    val onAdditionsItemClick: (ChipUIModel<AccommodationAdditionDomain>) -> Unit,

    val onRetryButtonClick: () -> Unit,
)